import axios from 'axios';

import { handleApiSucess, handleApiError, getRequestHeaders } from 'api/util.api';
import { handleRequest } from './util.api';

const getDepreciationsUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/depreciations`;

const getDepreciationByIdUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/depreciations/${dId}`;

const addDepreciationUrl = (cId, sId) => `/companies/${cId}/subcompanies/${sId}/depreciations`;

const updateDepreciationUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/depreciations/${dId}`;

const toggleDepreciationUrl = (dId, cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/depreciations/${dId}/toggle`;

const formConfigUrl = (cId, sId) =>
  `/companies/${cId}/subcompanies/${sId}/depreciations/form_config`;

const service = {
  configure(endpoint = '', auth = {}, defaultHeaders = {}) {
    this.endpoint = endpoint;
    this.auth = auth;
    this.defaultHeaders = defaultHeaders;
    this.getHeaders = getRequestHeaders(this.auth, this.defaultHeaders);

    this.axios = axios.create({
      baseURL: this.endpoint,
      timeout: 30000,
    });

    this.axios.interceptors.request.use((request) => {
      handleRequest(request);
      return request;
    });

    return this;
  },

  get(companyId, subcompanyId, filters, limit, page, orderBy, order) {
    const url = getDepreciationsUrl(companyId, subcompanyId);
    const params = { ...filters, limit, page, orderBy, order };
    return this.axios
      .get(url, { ...this.getHeaders(), params })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  getById(depreciationId, companyId, subcompanyId) {
    const url = getDepreciationByIdUrl(depreciationId, companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  add(companyId, subcompanyId, depreciation) {
    const url = addDepreciationUrl(companyId, subcompanyId);

    return this.axios
      .post(url, depreciation, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  update(depreciationId, companyId, subcompanyId, depreciation) {
    const url = updateDepreciationUrl(depreciationId, companyId, subcompanyId);

    return this.axios
      .put(url, depreciation, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  toggle(depreciationId, companyId, subcompanyId) {
    const url = toggleDepreciationUrl(depreciationId, companyId, subcompanyId);
    return this.axios
      .put(url, {}, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },

  formConfig(companyId, subcompanyId) {
    const url = formConfigUrl(companyId, subcompanyId);
    return this.axios
      .get(url, { ...this.getHeaders() })
      .then(handleApiSucess)
      .catch(handleApiError);
  },
};

export default service;



// WEBPACK FOOTER //
// src/lib/api/depreciations.api.js